import PropTypes from 'prop-types';
import React from 'react';

import i18n from '../../i18n';
import { CurrencyFormatter } from '../../utils/Intl';

import Exchange from '../../models/Exchange';
import User from '../../models/User';

import Tooltip from '../widget/Tooltip';

export default class InsuranceRow extends React.Component {
    static propTypes = {
        currency: PropTypes.string.isRequired,
        exchange: PropTypes.instanceOf(Exchange).isRequired,
        user: PropTypes.instanceOf(User).isRequired
    };

    isGuest() {
        const guest = this.props.exchange.get('guest');
        return guest && guest.id == this.props.user.id;
    }

    render() {
        return (
            <div className="form-group editable-field insurance_selected">
                <label>
                    {i18n.t('exchange:insurance')}
                    <Tooltip title={this.getTooltip()} />
                </label>
                {this.renderInsurance()}
            </div>
        );
    }

    getTooltip() {
        if (this.isGuest()) {
            if (this.props.exchange.isInsuranceRequired()) {
                return i18n.t('exchange:insurance_tooltip_guest_required');
            } else {
                return i18n.t('exchange:insurance_tooltip_guest_optional');
            }
        }
    }

    renderInsurance() {
        return this.isGuest() ? this.renderInsuranceForGuest() : this.renderInsuranceForHost();
    }

    renderInsuranceForGuest() {
        const { currency, exchange } = this.props;
        // an insurance is selected
        if (parseInt(exchange.get('insurance_selected'), 10)) {
            let detail = i18n.t('common:value_per_night', {
                value: CurrencyFormatter.format(exchange.get('insurance_selected'), currency),
                nb_night: exchange.getNightNb()
            });
            if (!exchange.get('insurance')) {
                detail = `${detail} (${i18n.t('common:optional', {
                    context: 'female'
                })})`;
            }
            return (
                <span className="value">
                    {detail}{' '}
                    <span className="pull-right">
                        {CurrencyFormatter.format(exchange.getInsuranceTotal(), currency)}
                    </span>
                </span>
            );
        }
        // insurance optional and exchange not finalized yet
        else if (!exchange.isInsuranceRequired() && !exchange.isFinalized()) {
            return (
                <span className="value">
                    <span className="pull-right">{i18n.t('common:optional', { context: 'female' })}</span>
                </span>
            );
        }
        // no insurance selected
        else {
            return (
                <span className="value">
                    <span className="pull-right">{i18n.t('exchange:no_insurance')}</span>
                </span>
            );
        }
    }

    renderInsuranceForHost() {
        if (this.props.exchange.isInsuranceRequired()) {
            return (
                <span className="value">
                    <span className="pull-right">{i18n.t('common:required')}</span>
                </span>
            );
        } else {
            return (
                <span className="value">
                    <span className="pull-right">{i18n.t('common:optional', { context: 'female' })}</span>
                </span>
            );
        }
    }
}
